import Vue from 'vue'

import App from './App.vue'
import {router} from './_helpers'
import { store } from './_store';

Vue.config.productionTip = false

import { configureFakeBackend } from './_helpers';
configureFakeBackend();

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  components: { App },
}).$mount('#app')

// new Vue({
//   render: h => h(App),
// }).$mount('#app')
